// extracted by mini-css-extract-plugin
export default {"lastUpdate":"userTable_lastUpdate__dK-ZO","widthbutton":"userTable_widthbutton__mbdK4"};